import React from 'react'
import { IphTemplateWidget } from './IphTemplateWidget'
import { TemplateLibraryWidget } from './TemplateLibraryWidget'
import { MediaFileWidget } from './MediaFileWidget'
import { MeetingTemplateWidget } from './MeetingTemplateWidget'

export interface ZocksReferenceWidgetProps {
  value: string
  onChange: (value: string | undefined) => void
  disabled: boolean
  required: boolean
  label: string
  config: Record<string, unknown>
  layer: 'account' | 'user'
  id: string
  setFieldUploading?: (fieldId: string, uploading: boolean) => void
}

export const referenceWidgetRegistry: Record<string, React.ComponentType<ZocksReferenceWidgetProps>> = {
  'input-parameters': IphTemplateWidget,
  'template-library': TemplateLibraryWidget,
  'media-file': MediaFileWidget,
  'meeting-template': MeetingTemplateWidget,
}
